import "./NotFoundPage.scss";
import { theme, Layout } from "antd";
import { Button, Typography } from "antd";
import { FrownOutlined, HomeOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const { Content } = Layout;
const { Title, Text } = Typography;

export default function NotFoundPage() {
  const { useToken } = theme;
  const { token } = useToken();
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate("/");
  };

  return (
    <Content className="notfound-cont">
      <div className="notfound-cont__iconWrapper">
        <FrownOutlined
          style={{
            fontSize: 56,
            color: token?.icons?.whiteIcon || "#FFF",
          }}
        />
      </div>

      <Title level={1} className="notfound-cont__title-404">
        404
      </Title>

      <Title level={2} className="notfound-cont__title-notfound">
        Page Not Found
      </Title>

      <div className="notfound-cont__divider" />

      <Text className="notfound-cont__description" type="secondary">
        Oops! The page you're looking for doesn't exist. It might have been
        moved, deleted, or the URL might be incorrect. Let's get you back on
        track.
      </Text>

      <Button
        type="primary"
        size="large"
        icon={<HomeOutlined />}
        onClick={handleGoHome}>
        Back to Home
      </Button>
    </Content>
  );
}
